import { login, getUserInfo, loginPhone } from '@/api/login'
import { collect } from '@/api/user'
import { sellerLogin, getInfo, platformLogin, getPlatformInfo } from '@/api/supplierLogin'

const user = {
  state: {
    token: localStorage.getItem('token'),
    userId: localStorage.getItem('userid'),
    name: localStorage.getItem('name'),
    avatar: localStorage.getItem('avatar'),
    openId: localStorage.getItem('openId'),
    buyParams: null,
    sellerToken: localStorage.getItem('sellerToken'),
    shopName: localStorage.getItem('shopName'),
    shopIcon: localStorage.getItem('shopIcon'),
    parentId: localStorage.getItem('parentId'),
    shopId: localStorage.getItem('shopId'),
    platformToken: localStorage.getItem('platformToken'),
    platformName: localStorage.getItem('platformName'),
    platformUserId: localStorage.getItem('platformUserId'),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_SELLERTOKEN: (state, sellerToken) => {
      state.sellerToken = sellerToken
      localStorage.setItem('sellerToken', sellerToken)
    },
    SET_PLATFORMTOKEN: (state, platformToken) => {
      state.platformToken = platformToken
      localStorage.setItem('platformToken', platformToken)
    },
    SET_USERID: (state, userId) => {
      state.userId = userId
      localStorage.setItem('userid', userId)
    },
    SET_NAME: (state, name) => {
      state.name = name
      localStorage.setItem('name', name)
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
      localStorage.setItem('avatar', avatar)
    },
    SET_OPENID: (state, openId) => {
      state.openId = openId
      localStorage.setItem('openId', openId)
    },
    SET_BUY_PARAMS (state, buyParams) { // 传给确认订单页面的参数
      state.buyParams = buyParams
    },
    SET_SHOPNAME: (state, shopName) => {
      state.shopName = shopName
      localStorage.setItem('shopName', shopName)
    },
    SET_SHOPICON: (state, shopIcon) => {
      state.shopIcon = shopIcon
      localStorage.setItem('shopIcon', shopIcon)
    },
    SET_PARENTID: (state, parentId) => {
      state.parentId = parentId
      localStorage.setItem('parentId', parentId)
    },
    SET_SHOPID: (state, shopId) => {
      state.shopId = shopId
      localStorage.setItem('shopId', shopId)
    },
    SET_PLATFORMNAME: (state, platformName) => {
      state.platformName = platformName
      localStorage.setItem('platformName', platformName)
    },
    SET_PLATFORMUSERID: (state, platformUserId) => {
      state.platformUserId = platformUserId
      localStorage.setItem('platformUserId', platformUserId)
    },
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login({ username: username, password: userInfo.password }).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    //卖家登录
    sellerLogin ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        sellerLogin(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          //存储token
          commit('SET_SELLERTOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 平台登录
    platformLogin ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        platformLogin(username, userInfo.password).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          commit('SET_SELLERTOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取平台用户信息
    getPlatformInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getPlatformInfo().then(response => {
          const data = response.data
          if (data.roles && data.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', data.roles)
          } else {
            reject('getPlatformInfo: roles must be a non-null array !')
          }
          commit('SET_PLATFORMNAME', data.username)
          commit('SET_PLATFORMUSERID', data.userId)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取卖家用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const data = res.data
          // debugger
          commit('SET_SHOPNAME', data.username)
          commit('SET_SHOPICON', data.icon)
          commit('SET_SHOPID', data.userId)
          commit('SET_PARENTID', data.parentId || '')
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 手机号登录
    LoginPhone ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        loginPhone(userInfo).then(response => {
          const data = response.data
          const tokenStr = data.tokenHead + data.token
          window.console.log('token', tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          const data = response.data
          commit('SET_NAME', data.username)
          commit('SET_AVATAR', data.icon)
          commit('SET_USERID', data.id)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    LogOut ({ commit }) {
      console.log('退出')
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        commit('SET_SELLERTOKEN', '')
        commit('SET_NAME', '')
        commit('SET_AVATAR', '')
        commit('SET_USERID', '')
        commit('SET_SHOPNAME', '')
        commit('SET_SHOPICON',)
        commit('SET_SHOPID', '')
        commit('SET_PARENTID', '')
        localStorage.removeItem('token')
        localStorage.removeItem('sellerToken')
        console.log('token ', localStorage.getItem('token'))
        console.log('sellerToken ', localStorage.getItem('sellerToken'))
        resolve()
      })
    },

    // 收藏功能
    collect ({ commit }, content) {
      return new Promise((resolve, reject) => {
        collect(content).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js